/* @flow */
import React from 'react';
import BoxHeader from 'components/BoxHeader.jsx';
import Link from 'components/Link.jsx';
import Dialog from 'components/Dialog.jsx';
import DialogBody from 'components/DialogBody.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';
import ToastActions from 'actions/ToastActions';
import TreasurerAddBankAccountModal from 'payments/components/TreasurerAddBankAccountModal.jsx';
import ConnectedBankAccountActions from 'payments/actions/ConnectedBankAccountActions';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import { mountModal } from 'lib/modal';
import Button from 'components/Button.jsx';
import Text from 'components/Text.jsx';
import TitleHeader from 'components/TitleHeader.jsx';

import './styles/PendingConnectedBankAccountRequestsModal.scss';

type Props = {
  onRequestHide: () => void,
  pendingBankAccountRequests: ConnectedBankAccount[],
  refreshPendingBankAccountRequests: () => void,
};

class PendingConnectedBankAccountRequestsModal extends React.Component {
  props: Props;

  onBankAccountAdded = () => {
    ToastActions.showSuccessToast('The account was approved.');
    this.props.refreshPendingBankAccountRequests();
  }

  decline = (connectedBankAccountUUID: string) => {
    const modal = (
      <ConfirmDialog
        eventScreenName="PendingConnectedBankAccountRequestsModal"
        title="Are you sure you want to decline this deposit request?"
        subtitle="This action cannot be undone"
        onConfirm={() => ConnectedBankAccountActions.reject(connectedBankAccountUUID)}
      />
    );

    mountModal(modal, this);
  }

  renderPendingBankAccountRequest(connectedBankAccount: ConnectedBankAccount) {
    const modal = (
      <TreasurerAddBankAccountModal
        onBankAccountAdded={this.onBankAccountAdded}
        connectedBankAccount={connectedBankAccount}
      />
    );

    return (
      <div className="PendingConnectedBankAccountRequestsModal-table-item">
        {connectedBankAccount.getConnectedUserName()}
        <div>
          <Link
            color="lava"
            weight="semibold"
            onClick={() => this.decline(connectedBankAccount.id)}
            className="PendingConnectedBankAccountRequestsModal-reject"
            eventElementName="PendingConnectedBankAccountRequestsModal-reject">
            Decline
          </Link>
          <ModalTrigger modal={modal}>
            <Link weight="semibold">
              Approve
            </Link>
          </ModalTrigger>
        </div>
      </div>
    );
  }

  renderResults() {
    const { pendingBankAccountRequests } = this.props;

    return (
      <div>
        <table className="PendingConnectedBankAccountRequestsModal-table">
          <thead>
            <tr>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            {pendingBankAccountRequests.map(pendingBankAccountRequest =>
              <tr key={pendingBankAccountRequest.id}>
                <td>
                  {this.renderPendingBankAccountRequest(pendingBankAccountRequest)}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <footer>
          <Text color="thunder" size="xxsmall">
            Once approved you will will be able to manage all the deposit access from
            {' '}
            <Link to="/settings/transactions">your settings</Link>.
          </Text>
        </footer>
      </div>
    );
  }

  renderNoResults() {
    const subtext = (
      <span>
        You can manage all the deposit access from
        {' '}
        <Link to="/settings/transactions">your settings</Link>.
      </span>
    );

    return (
      <TitleHeader
        title="You have no pending deposit requests."
        subtext={subtext}
        action={<Button onClick={this.props.onRequestHide}>Close</Button>}
        bottomMargin="none"
      />
    );
  }

  render() {
    const { pendingBankAccountRequests } = this.props;
    const subtext = pendingBankAccountRequests.length > 0 ?
      `${pendingBankAccountRequests.length} people would like to deposit funds directly to your account` : null;

    return (
      <Dialog {...this.props} className="PendingConnectedBankAccountRequestsModal">
        <BoxHeader
          title="Deposit requests"
          subtext={subtext}
        />
        <DialogBody>
          {pendingBankAccountRequests.length > 0 && this.renderResults()}
          {pendingBankAccountRequests.length === 0 && this.renderNoResults()}
        </DialogBody>
      </Dialog>
    );
  }
}

export default PendingConnectedBankAccountRequestsModal;



// WEBPACK FOOTER //
// ./src/payments/components/PendingConnectedBankAccountRequestsModal.jsx